import React, {useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import CreateNewPasswordForm from "./CreateNewPassword";
import {Button} from "./Login";

function obfuscateEmailKeepLastChar(email: string) {
  if (!email.includes("@")) return email;

  const [localPart, domain] = email.split("@");

  if (localPart.length <= 1) return `${localPart}@${domain}`;

  const firstChar = localPart[0];
  const lastChar = localPart.slice(-1);
  const stars = "*".repeat(localPart.length - 2);

  return `${firstChar}${stars}${lastChar}@${domain}`;
}

export default function ResetPage() {
  const navigate = useNavigate();
  const [step, setStep] = useState("change");
  const [email, setEmail] = useState("");

  return (
    <div className="bg-[#f8f9fb] w-screen h-screen flex flex-col items-center justify-center ">
      <div className="bg-white lg:shadow-[0px_4px_50px_0px_#0000001A] lg:rounded-[20px] px-9 py-6">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginBottom: "30px",
            gap: "10px",
          }}
        >
          <img width={50} height={50} src="/logo2.svg" alt="" />

          <p style={{color: "#333333", fontWeight: 700, fontSize: "2rem"}}>
            eFTD Africa
          </p>
        </div>

        {step === "change" ? (
          <div className="lg:max-w-[468px] w-full h-full lg:h-max">
            <h2 className="text-[28px] font-bold text-greyscale-700 mb-6">
              Create New Password
            </h2>
            <p className="text-sm text-greyscale-300">
              Please choose a combination of what you can easily remember.
            </p>
            <div className="border-b border-b-greyscale-100 border-dashed my-8" />
            <CreateNewPasswordForm email={email} setStep={setStep} />
          </div>
        ) : (
          <div className="max-w-[468px] w-full  flex flex-col items-center justify-center gap-6">
            <h2 className="text-[32px] font-bold text-greyscale-900 my-4">
              Success!
            </h2>
            <p className="text-base text-greyscale-400 mb-4">
              Your password has been changed successfully
            </p>

            <Button
              onClick={() => navigate("/login")}
              className="w-full !bg-black !text-white"
            >
              Proceed to Login
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
